import React from "react";
import { OnClickButton } from "../../../components/SkyFramework/Buttons";
import { Tooltip } from "../../../components/SkyFramework/Helpers/Tooltip";

import { trueOrFalseIfExist, trueOrFalse, required, ifZero, noMaximum, capitalizeFirstLetter, specialMaximum } from "../../../helpers/util";


export const initialState = (phrasebook, id) => {
  var state = {
    id: id,
    service_number_type: undefined,
    number_types: [{ value: 'Fixed', label: phrasebook.common.fixed }, { value: 'Mobile', label: phrasebook.profile.mobile }, { value: 'Non-Geo', label: phrasebook.common.non_geo }],
    service_types: [{ value: 'ITFS', label: 'ITFS' }, { value: 'UIFN', label: 'UIFN' }, { value: 'DID', label: 'DID' }, { value: 'SIP Trunking', label: 'SIP Trunking' }],
    outbound_call_display_formats: [{ value: 'E.164', label: 'E.164' }, { value: 'local CLI', label: 'local CLI' }],
    address_types: [{ value: 'local', label: 'Local' }, { value: 'worldwide', label: 'Worldwide' }],
    vendors: undefined,
    dialcodes: undefined,

    // Service Type Attributes
    expired: undefined,
    vendor_id: undefined,
    vendor_plan: undefined,
    vendor_option: undefined,
    service_type: 'ITFS',
    number_type: undefined,
    outbound_calling_enabled: undefined,
    outbound_call_display_format: undefined,
    jurisdiction: undefined,
    jurisdiction_dial_code: undefined,
    cities: [],
    // Characteristics
    service_access_code: undefined,
    accessibility: [],
    accessibility_remarks: undefined,
    provisioning_lead_time: undefined,
    maximum_call_duration: undefined,
    conc_df_callpernumber: undefined,  // ADD
    concurrent_call_expandable: undefined,
    conc_max_callpnumber: undefined, // REVISE
    concurrent_maximum_calls: undefined, // ADD

    calling_card_usage_permitted: undefined,
    local_caller_cli_supported: undefined,
    t38_fax_supported: undefined,
    emergency_services: undefined,


    //Requirements
    usage_forecast_req: false, //revise
    purpose_application_req: false,
    itu_assignment_notification_req: false,
    business_nature_req: false,
    business_registration_req: false,
    business_registration_doc_req: false,
    buss_reg_doctypes_req: undefined,
    end_user_name_req: false,
    end_user_contact_req: false,
    end_user_address_req: false,
    end_user_address_type: undefined,
    end_user_address_proof_req: false,
    end_user_address_proof_required: undefined,
    declaration_letter_req: false,
    declaration_letter_link: undefined,
    authorised_person_passport_id_req: false,
    authpers_passportholding_req: false,
    portability: false,
    portability_options: [],
    prt_consentletter_req: false,
    prt_consentletter_link: undefined,
    prt_hstcarriers_req: false, //revise
    portability_forms: false,
    portability_forms_link: undefined,
    portability_latest_invoices_req: false, //revise

    additional_remarks: undefined,

    // Tariff Attributes

    tariff_types: [{ value: 'standard', label: phrasebook.common.standard }, { value: 'customized', label: phrasebook.common.customized }],
    currencies: [{ value: 'USD', label: 'USD' }, { value: 'EUR', label: 'EUR' }, { value: 'GBP', label: 'GBP' }, { value: 'HKD', label: 'HKD' }, { value: 'CNY', label: 'CNY' }, { value: 'SGD', label: 'SGD' }],
    type: 'standard',
    nrc: undefined,
    mrc: undefined,
    fix_usage_rate: undefined,
    mobile_usage_rate: undefined,
    payphone_usage_rate: undefined,
    nrc_channel_charges: undefined,
    mrc_channel_charges: undefined,
    inbound_charges: undefined,
    outbound_charges_fixed: undefined,
    outbound_charges_mobile: undefined,
    outbound_charges_special: undefined,
    currency: 'USD',

    submitted: false
  }
  return state;
}

export const updateState = (servicenumbertype) => {
  return {
    expired: servicenumbertype.expired,
    vendor_id: servicenumbertype.vendor_id,
    vendor_plan: servicenumbertype.vendor_plan,
    vendor_option: servicenumbertype.vendor_option,
    service_type: servicenumbertype.service_type,
    number_type: servicenumbertype.number_type,
    outbound_calling_enabled: servicenumbertype.outbound_calling_enabled,
    outbound_call_display_format: servicenumbertype.outbound_call_display_format,
    jurisdiction: servicenumbertype.jurisdiction,
    jurisdiction_dial_code: servicenumbertype.jurisdiction_dial_code,
    cities: servicenumbertype.cities,
    service_access_code: servicenumbertype.service_access_code,
    accessibility: servicenumbertype.accessibility,
    accessibility_remarks: servicenumbertype.accessibility_remarks,
    provisioning_lead_time: servicenumbertype.provisioning_lead_time,
    maximum_call_duration: servicenumbertype.maximum_call_duration,
    conc_df_callpernumber: servicenumbertype.conc_df_callpernumber,
    concurrent_call_expandable: servicenumbertype.concurrent_call_expandable,
    conc_max_callpnumber: servicenumbertype.conc_max_callpnumber,
    concurrent_maximum_calls: servicenumbertype.concurrent_maximum_calls,
    calling_card_usage_permitted: servicenumbertype.calling_card_usage_permitted,
    local_caller_cli_supported: servicenumbertype.local_caller_cli_supported,
    t38_fax_supported: servicenumbertype.t38_fax_supported,
    emergency_services: servicenumbertype.emergency_services,
    usage_forecast_req: servicenumbertype.usage_forecast_req,
    purpose_application_req: servicenumbertype.purpose_application_req,
    itu_assignment_notification_req: servicenumbertype.itu_assignment_notification_req,
    business_nature_req: servicenumbertype.business_nature_req,
    business_registration_req: servicenumbertype.business_registration_req,
    business_registration_doc_req: servicenumbertype.business_registration_doc_req,
    buss_reg_doctypes_req: servicenumbertype.buss_reg_doctypes_req,
    end_user_name_req: servicenumbertype.end_user_name_req,
    end_user_contact_req: servicenumbertype.end_user_contact_req,
    end_user_address_req: servicenumbertype.end_user_address_req,
    end_user_address_type: servicenumbertype.end_user_address_type,
    end_user_address_proof_req: servicenumbertype.end_user_address_proof_req,
    end_user_address_proof_required: servicenumbertype.end_user_address_proof_required,
    declaration_letter_req: servicenumbertype.declaration_letter_req,
    declaration_letter_link: servicenumbertype.declaration_letter_link,
    authorised_person_passport_id_req: servicenumbertype.authorised_person_passport_id_req,
    authpers_passportholding_req: servicenumbertype.authpers_passportholding_req,
    portability: servicenumbertype.portability,
    portability_options: servicenumbertype.portability_options,
    prt_consentletter_req: servicenumbertype.prt_consentletter_req,
    prt_consentletter_link: servicenumbertype.prt_consentletter_link,
    prt_hstcarriers_req: servicenumbertype.prt_hstcarriers_req,
    portability_forms: servicenumbertype.portability_forms,
    portability_forms_link: servicenumbertype.portability_forms_link,
    portability_latest_invoices_req: servicenumbertype.portability_latest_invoices_req,
    additional_remarks: servicenumbertype.additional_remarks,
    type: servicenumbertype.tariff.type,
    nrc: servicenumbertype.tariff.nrc,
    mrc: servicenumbertype.tariff.mrc,
    fix_usage_rate: servicenumbertype.tariff.fix_usage_rate,
    mobile_usage_rate: servicenumbertype.tariff.mobile_usage_rate,
    payphone_usage_rate: servicenumbertype.tariff.payphone_usage_rate,
    nrc_channel_charges: servicenumbertype.tariff.nrc_channel_charges,
    mrc_channel_charges: servicenumbertype.tariff.mrc_channel_charges,
    inbound_charges: servicenumbertype.tariff.inbound_charges,
    outbound_charges_fixed: servicenumbertype.tariff.outbound_charges_fixed,
    outbound_charges_mobile: servicenumbertype.tariff.outbound_charges_mobile,
    outbound_charges_special: servicenumbertype.tariff.outbound_charges_special,
    currency: servicenumbertype.tariff.currency,
    description: servicenumbertype.tariff.additional_remarks,
    service_number_type: servicenumbertype
  }
}

export const submitValues = (actualState) => {
  return {

    expired: actualState.expired,
    vendor_id: actualState.vendor_id,
    vendor_plan: actualState.vendor_plan,
    vendor_option: actualState.vendor_option,
    service_type: actualState.service_type,
    number_type: actualState.number_type,
    outbound_calling_enabled: actualState.outbound_calling_enabled,
    outbound_call_display_format: actualState.outbound_call_display_format,
    jurisdiction: actualState.jurisdiction,
    jurisdiction_dial_code: actualState.jurisdiction_dial_code,
    cities: actualState.cities,
    service_access_code: actualState.service_access_code,
    accessibility: actualState.accessibility,
    accessibility_remarks: actualState.accessibility_remarks,
    provisioning_lead_time: actualState.provisioning_lead_time,
    maximum_call_duration: actualState.maximum_call_duration,
    conc_df_callpernumber: actualState.conc_df_callpernumber,
    concurrent_call_expandable: actualState.concurrent_call_expandable,
    conc_max_callpnumber: actualState.conc_max_callpnumber,
    concurrent_maximum_calls: actualState.concurrent_maximum_calls,
    calling_card_usage_permitted: actualState.calling_card_usage_permitted,
    local_caller_cli_supported: actualState.local_caller_cli_supported,
    t38_fax_supported: actualState.t38_fax_supported,
    emergency_services: actualState.emergency_services,
    usage_forecast_req: actualState.usage_forecast_req,
    purpose_application_req: actualState.purpose_application_req,
    itu_assignment_notification_req: actualState.itu_assignment_notification_req,
    business_nature_req: actualState.business_nature_req,
    business_registration_req: actualState.business_registration_req,
    business_registration_doc_req: actualState.business_registration_doc_req,
    buss_reg_doctypes_req: actualState.buss_reg_doctypes_req,
    end_user_name_req: actualState.end_user_name_req,
    end_user_contact_req: actualState.end_user_contact_req,
    end_user_address_req: actualState.end_user_address_req,
    end_user_address_type: actualState.end_user_address_type,
    end_user_address_proof_req: actualState.end_user_address_proof_req,
    end_user_address_proof_required: actualState.end_user_address_proof_required,
    declaration_letter_req: actualState.declaration_letter_req,
    declaration_letter_link: actualState.declaration_letter_link,
    authorised_person_passport_id_req: actualState.authorised_person_passport_id_req,
    authpers_passportholding_req: actualState.authpers_passportholding_req,
    portability: actualState.portability,
    portability_options: actualState.portability_options,
    prt_consentletter_req: actualState.prt_consentletter_req,
    prt_consentletter_link: actualState.prt_consentletter_link,
    prt_hstcarriers_req: actualState.prt_hstcarriers_req,
    portability_forms: actualState.portability_forms,
    portability_forms_link: actualState.portability_forms_link,
    portability_latest_invoices_req: actualState.portability_latest_invoices_req,
    additional_remarks: actualState.additional_remarks,
    type: actualState.type,
    nrc: actualState.nrc,
    mrc: actualState.mrc,
    fix_usage_rate: actualState.fix_usage_rate,
    mobile_usage_rate: actualState.mobile_usage_rate,
    payphone_usage_rate: actualState.payphone_usage_rate,
    nrc_channel_charges: actualState.nrc_channel_charges,
    mrc_channel_charges: actualState.mrc_channel_charges,
    inbound_charges: actualState.inbound_charges,
    outbound_charges_fixed: actualState.outbound_charges_fixed,
    outbound_charges_mobile: actualState.outbound_charges_mobile,
    outbound_charges_special: actualState.outbound_charges_special,
    currency: actualState.currency,
    description: actualState.additional_remarks,
  }
}



/**FORM */
export const serviceNumberTypeForm = (phrasebook, actualState, selects, addCity) => {
  const inputs = [
    { label: phrasebook.headerlinks.vendors, type: "section" },
    [{ label: phrasebook.common.expired, type: "checkbox", id: "expired", name: "expired", value: actualState.expired }],
    [{ label: phrasebook.headerlinks.vendors, type: "select", id: "vendor_id", name: "vendor_id", options: selects.vendors, selected: actualState.vendor_id, empty_option: true, required: true }, // ALL
    { label: phrasebook.common.plan, type: "text", placeholder: actualState.vendor_plan, tooltip: phrasebook.tooltip.vendor_plan, id: "vendor_plan", name: "vendor_plan", value: actualState.vendor_plan },
    { label: phrasebook.common.option, type: "text", placeholder: actualState.vendor_option, tooltip: phrasebook.tooltip.vendor_option, id: "vendor_option", name: "vendor_option", value: actualState.vendor_option, required: true },
    ],
    { label: phrasebook.numbers.service_type, type: "select", id: "service_type", name: "service_type", options: actualState.service_types, selected: actualState.service_type, required: true }, // ALL

    { label: phrasebook.profile.jurisdiction, type: "section" },
    { label: phrasebook.profile.jurisdiction, type: "select", id: "jurisdiction", name: "jurisdiction", options: selects.dialcodes, selected: JSON.stringify({ name: actualState.jurisdiction, dialcode: actualState.jurisdiction_dial_code }), empty_option: true, required: true }, // ALL

    { label: phrasebook.numbers.accessibility, type: "section" },
    [{ label: phrasebook.numbers.local_fixed, type: "checkbox", id: "accessibility", name: "local_fixed", value: actualState.accessibility.includes('local_fixed') ? true : false },
    { label: phrasebook.numbers.local_mobile, type: "checkbox", id: "accessibility", name: "local_mobile", value: actualState.accessibility.includes('local_mobile') ? true : false },
    { label: phrasebook.numbers.local_payphone, type: "checkbox", id: "accessibility", name: "local_payphone", value: actualState.accessibility.includes('local_payphone') ? true : false },
    { label: phrasebook.numbers.from_overseas, type: "checkbox", id: "accessibility", name: "from_overseas", value: actualState.accessibility.includes('from_overseas') ? true : false },
    { label: phrasebook.numbers.mobile_roamers, type: "checkbox", id: "accessibility", name: "mobile_roamers", value: actualState.accessibility.includes('mobile_roamers') ? true : false },
    { label: phrasebook.numbers.on_net_only, type: "checkbox", id: "accessibility", name: "on-net_only", value: actualState.accessibility.includes('on-net_only') ? true : false },
    { label: phrasebook.numbers.universal, type: "checkbox", id: "accessibility", name: "universal", value: actualState.accessibility.includes('universal') ? true : false }],
    { label: phrasebook.numbers.accessibility_remarks, type: "textarea", placeholder: actualState.accessibility_remarks, tooltip: phrasebook.tooltip.accessibility_remarks, id: "accessibility_remarks", name: "accessibility_remarks", value: actualState.accessibility_remarks },

    { label: phrasebook.common.characteristics, type: "section", id: "characteristics" },

    { label: phrasebook.numbers.provisioning_lead_time, type: "text", placeholder: actualState.provisioning_lead_time, tooltip: phrasebook.tooltip.provisioning_lead_time, id: "provisioning_lead_time", name: "provisioning_lead_time", value: actualState.provisioning_lead_time },

    { label: phrasebook.numbers.maximum_call_duration, type: "text", placeholder: actualState.maximum_call_duration, id: "maximum_call_duration", name: "maximum_call_duration", tooltip: phrasebook.tooltip.maximum_call_duration, value: actualState.maximum_call_duration },

    { label: phrasebook.numbers.concurrent_capabilities, type: "subsection", id: "concurrent_title" },

    { label: phrasebook.numbers.concurrent_call_expandable, type: "checkbox", tooltip: phrasebook.tooltip.concurrent_call_expandable, id: "concurrent_call_expandable", name: "concurrent_call_expandable", value: actualState.concurrent_call_expandable },

    { label: phrasebook.numbers.concurrent_maximum_calls, type: "text", tooltip: phrasebook.tooltip.concurrent_maximum_calls, placeholder: actualState.concurrent_maximum_calls, id: "concurrent_maximum_calls", name: "concurrent_maximum_calls", value: actualState.concurrent_maximum_calls },

    { label: phrasebook.common.others, type: "subsection", id: "others" },

    { label: phrasebook.numbers.local_caller_cli_supported, type: "checkbox", id: "local_caller_cli_supported", name: "local_caller_cli_supported", value: actualState.local_caller_cli_supported },
    { label: phrasebook.numbers.t38_fax_supported, type: "checkbox", id: "t38_fax_supported", name: "t38_fax_supported", value: actualState.t38_fax_supported },

    { label: phrasebook.numbers.calling_card_usage_permitted, type: "checkbox", id: "calling_card_usage_permitted", name: "calling_card_usage_permitted", value: actualState.calling_card_usage_permitted },



    { label: phrasebook.orders.customer_information_req, type: "section" },

    { label: phrasebook.numbers.declaration_letter_req, type: "checkbox", id: "declaration_letter_req", name: "declaration_letter_req", value: actualState.declaration_letter_req },

    { label: phrasebook.numbers.usage_forecast_req, type: "checkbox", id: "usage_forecast_req", name: "usage_forecast_req", tooltip: phrasebook.tooltip.usage_forecast_req, value: actualState.usage_forecast_req },

    { label: phrasebook.numbers.purpose_application_req, type: "checkbox", id: "purpose_application_req", name: "purpose_application_req", tooltip: phrasebook.tooltip.purpose_application_req, value: actualState.purpose_application_req },

    { label: phrasebook.numbers.business_req, type: "subsection" },

    { label: phrasebook.numbers.business_nature_req, type: "checkbox", id: "business_nature_req", name: "business_nature_req", tooltip: phrasebook.tooltip.business_nature_req, value: actualState.business_nature_req },

    { label: phrasebook.numbers.business_registration_req, type: "checkbox", id: "business_registration_req", name: "business_registration_req", tooltip: phrasebook.tooltip.business_registration_req, value: actualState.business_registration_req },
    { label: phrasebook.numbers.business_registration_doc_req, type: "checkbox", id: "business_registration_doc_req", name: "business_registration_doc_req", value: actualState.business_registration_doc_req },

    { label: phrasebook.numbers.end_user_req, type: "subsection" },

    { label: phrasebook.numbers.end_user_name_req, type: "checkbox", id: "end_user_name_req", name: "end_user_name_req", tooltip: phrasebook.tooltip.end_user_name_req, value: actualState.end_user_name_req },
    { label: phrasebook.numbers.end_user_contact_req, type: "checkbox", id: "end_user_contact_req", name: "end_user_contact_req", value: actualState.end_user_contact_req, tooltip: phrasebook.tooltip.end_user_contact_req },
    { label: phrasebook.numbers.end_user_address_req, type: "checkbox", id: "end_user_address_req", name: "end_user_address_req", value: actualState.end_user_address_req, tooltip: phrasebook.tooltip.end_user_address_req },



    { label: phrasebook.numbers.authorised_person_passport_id_req, type: "checkbox", id: "authorised_person_passport_id_req", name: "authorised_person_passport_id_req", value: actualState.authorised_person_passport_id_req },

    { label: phrasebook.numbers.authpers_passportholding_req, type: "checkbox", id: "authpers_passportholding_req", name: "authpers_passportholding_req", value: actualState.authpers_passportholding_req },



    { label: phrasebook.numbers.portability, type: "section" },

    { label: phrasebook.numbers.portability_enabled, type: "checkbox", id: "portability", name: "portability", tooltip: phrasebook.tooltip.portability, value: actualState.portability },



    { label: phrasebook.headerlinks.pricing, type: "section" },

    { label: phrasebook.common.type, type: "select", id: "type", name: "type", options: actualState.tariff_types, selected: actualState.type },
    { label: phrasebook.references.currency, type: "select", id: "currency", name: "currency", options: actualState.currencies, selected: actualState.currency, tooltip: phrasebook.tooltip.currency },

    [{ label: phrasebook.pricing.nrc, type: "text", placeholder: actualState.nrc, id: "nrc", name: "nrc", value: actualState.nrc, tooltip: phrasebook.tooltip.nrc },

    { label: phrasebook.pricing.mrc, type: "text", placeholder: actualState.mrc, id: "mrc", name: "mrc", value: actualState.mrc, tooltip: phrasebook.tooltip.mrc }],

    { label: phrasebook.numbers.additional_remarks, type: "section", tooltip: phrasebook.tooltip.additional_remarks },

    { type: "textarea", placeholder: actualState.additional_remarks, id: "additional_remarks", name: "additional_remarks", value: actualState.additional_remarks }
  ]
  // HERE COMES THE CONDITIONS

  if (actualState.service_type === 'SIP Trunking') {
    var index = inputs.findIndex(p => p.id === "t38_fax_supported");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.emergency_services, type: "checkbox", id: "emergency_services", name: "emergency_services", tooltip: phrasebook.tooltip.emergency_services, value: actualState.emergency_services })

    index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "mrc"));

    inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_channel_charges, type: "subsection" });
    inputs.splice((index + 2), 0,
      [{ label: phrasebook.pricing.nrc_channel_charges, type: "text", placeholder: actualState.nrc_channel_charges, id: "nrc_channel_charges", name: "nrc_channel_charges", value: actualState.nrc_channel_charges, tooltip: phrasebook.tooltip.nrc_channel_charges }, { label: phrasebook.pricing.mrc_channel_charges, type: "text", placeholder: actualState.mrc_channel_charges, id: "mrc_channel_charges", name: "mrc_channel_charges", value: actualState.mrc_channel_charges, tooltip: phrasebook.tooltip.mrc_channel_charges }]);


    inputs.splice((index + 3), 0, { label: phrasebook.pricing.outbound_charges, type: "subsection" });
    inputs.splice((index + 4), 0, [{ label: phrasebook.pricing.outbound_charges_fixed, type: "text", placeholder: actualState.outbound_charges_fixed, id: "outbound_charges_fixed", name: "outbound_charges_fixed", value: actualState.outbound_charges_fixed, tooltip: phrasebook.tooltip.outbound_charges_fixed }, { label: phrasebook.pricing.outbound_charges_mobile, type: "text", placeholder: actualState.outbound_charges_mobile, id: "outbound_charges_mobile", name: "outbound_charges_mobile", value: actualState.outbound_charges_mobile, tooltip: phrasebook.tooltip.outbound_charges_mobile }, { label: phrasebook.pricing.outbound_charges_special, type: "text", placeholder: actualState.outbound_charges_special, id: "outbound_charges_special", name: "outbound_charges_special", value: actualState.outbound_charges_special, tooltip: phrasebook.tooltip.outbound_charges_special }]);

  }

  if (actualState.service_type === 'UIFN') {
    var index = inputs.findIndex(p => p.id === "provisioning_lead_time");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.service_access_code, type: "text", placeholder: actualState.service_access_code, id: "service_access_code", name: "service_access_code", value: actualState.service_access_code, tooltip: phrasebook.tooltip.service_access_code })

    index = inputs.findIndex(k => k.label === phrasebook.numbers.purpose_application_req);
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.itu_assignment_notification_req, type: "checkbox", id: "itu_assignment_notification_req", name: "itu_assignment_notification_req", tooltip: phrasebook.tooltip.itu_assignment_notification_req, value: actualState.itu_assignment_notification_req })

  }

  if (actualState.service_type === 'ITFS' || actualState.service_type === 'UIFN') {

    let index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "mrc"));

    inputs.splice((index + 1), 0, { label: phrasebook.pricing.per_minute_rate, type: "subsection" });
    inputs.splice((index + 2), 0, [{ label: phrasebook.pricing.fix_usage_rate, type: "text", placeholder: actualState.fix_usage_rate, id: "fix_usage_rate", name: "fix_usage_rate", value: actualState.fix_usage_rate }, { label: phrasebook.pricing.mobile_usage_rate, type: "text", placeholder: actualState.mobile_usage_rate, id: "mobile_usage_rate", name: "mobile_usage_rate", value: actualState.mobile_usage_rate }, { label: phrasebook.pricing.payphone_usage_rate, type: "text", placeholder: actualState.payphone_usage_rate, id: "payphone_usage_rate", name: "payphone_usage_rate", value: actualState.payphone_usage_rate }])
  }
  if (actualState.service_type === 'DID' || actualState.service_type === 'SIP Trunking') {
    var index = inputs.findIndex(p => p.id === "jurisdiction");
    inputs.splice((index + 1), 0, { label: phrasebook.references.cities, type: "subsection" }, { type: "button", button: <OnClickButton onClick={addCity} title={`${phrasebook.common.add}  ${phrasebook.references.city}`} /> })

    actualState.cities.forEach((city, cityIndex) => {
      inputs.splice((index + 2 + cityIndex), 0, [{ label: phrasebook.references.city, type: "text", placeholder: city.city, id: "city" + cityIndex, name: "city" + cityIndex, value: city.city }, { label: phrasebook.references.city_dial_code, type: "text", placeholder: city.city_dial_code, id: "city_dial_code" + cityIndex, name: "city_dial_code" + cityIndex, value: city.city_dial_code }])
    })

    index = inputs.findIndex(p => p.id === "provisioning_lead_time");
    inputs.splice((index + 1), 0, { label: phrasebook.common.number, type: "select", id: "number_type", name: "number_type", options: actualState.number_types, selected: actualState.number_type, empty_option: true, tooltip: phrasebook.tooltip.number_type })

    inputs.splice((index + 2), 0, { label: phrasebook.numbers.outbound, type: "subsection" })
    inputs.splice((index + 3), 0, { label: phrasebook.numbers.outbound_calling_enabled, type: "checkbox", id: "outbound_calling_enabled", name: "outbound_calling_enabled", tooltip: phrasebook.tooltip.outbound_calling_enabled, value: actualState.outbound_calling_enabled })

    index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.id === "mrc"));
    inputs.splice((index + 1), 0, { label: phrasebook.pricing.inbound_charges_per_minute, type: "subsection" });
    inputs.splice((index + 2), 0, { label: phrasebook.pricing.inbound_charges, type: "text", placeholder: actualState.inbound_charges, id: "inbound_charges", name: "inbound_charges", value: actualState.inbound_charges },);
  }
  if (actualState.outbound_calling_enabled === true) {
    var index = inputs.findIndex(p => p.id === "outbound_calling_enabled");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.outbound_call_display_format, type: "select", id: "outbound_call_display_format", name: "outbound_call_display_format", options: actualState.outbound_call_display_formats, selected: actualState.outbound_call_display_format, empty_option: true, tooltip: phrasebook.tooltip.outbound_call_display_format });
  }

  if (actualState.concurrent_call_expandable === true) {
    var index = inputs.findIndex(p => p.id === "concurrent_call_expandable");
    var index_default = inputs.findIndex(p => p.id === "conc_max_callpnumber");
    if (index_default !== -1) inputs.splice((index_default), 1);
    inputs.splice((index + 1), 0,
      { label: phrasebook.numbers.conc_df_callpernumber, type: "text", tooltip: phrasebook.tooltip.conc_df_callpernumber, id: "conc_df_callpernumber", name: "conc_df_callpernumber", value: actualState.conc_df_callpernumber },
    );
  } else {
    var index = inputs.findIndex(p => p.id === "concurrent_call_expandable");
    var index_default = inputs.findIndex(p => p.id === "conc_df_callpernumber");
    if (index_default !== -1) inputs.splice((index_default), 1);
    inputs.splice((index + 1), 0,
      { label: phrasebook.numbers.conc_max_callpnumber, type: "text", tooltip: phrasebook.tooltip.conc_max_callpnumber, id: "conc_max_callpnumber", name: "conc_max_callpnumber", value: actualState.conc_max_callpnumber },
    );


  }

  if (actualState.end_user_address_req === true) {
    var index = inputs.findIndex(p => p.id === "end_user_address_req");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.end_user_address_type, type: "select", id: "end_user_address_type", name: "end_user_address_type", options: actualState.address_types, selected: actualState.end_user_address_type, empty_option: true })
    inputs.splice((index + 2), 0, { label: phrasebook.numbers.end_user_address_proof_req, type: "checkbox", id: "end_user_address_proof_req", name: "end_user_address_proof_req", value: actualState.end_user_address_proof_req });
  }

  if (actualState.end_user_address_proof_req === true) {
    var index = inputs.findIndex(p => p.id === "end_user_address_proof_req");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.end_user_address_proof_required, type: "text", placeholder: actualState.end_user_address_proof_required, id: "end_user_address_proof_required", name: "end_user_address_proof_required", value: actualState.end_user_address_proof_required })
  }

  if (actualState.business_registration_doc_req === true) {
    var index = inputs.findIndex(p => p.id === "business_registration_doc_req");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.buss_reg_doctypes_req, type: "text", placeholder: actualState.buss_reg_doctypes_req, id: "buss_reg_doctypes_req", name: "buss_reg_doctypes_req", value: actualState.buss_reg_doctypes_req })
  }

  if (actualState.portability === true) {
    var index = inputs.findIndex(p => p.id === "portability");
    inputs.splice((index + 1), 0, { label: phrasebook.numbers.portability_req, type: "subsection", id: "portability_req" })

    inputs.splice((index + 2), 0, { label: phrasebook.numbers.prt_consentletter_req, type: "checkbox", id: "prt_consentletter_req", name: "prt_consentletter_req", value: actualState.prt_consentletter_req })


    inputs.splice((index + 3), 0, { label: phrasebook.numbers.prt_hstcarriers_req, type: "checkbox", id: "prt_hstcarriers_req", name: "prt_hstcarriers_req", value: actualState.prt_hstcarriers_req })

    inputs.splice((index + 4), 0, { label: phrasebook.numbers.portability_forms, type: "checkbox", id: "portability_forms", name: "portability_forms", value: actualState.portability_forms })

    inputs.splice((index + 5), 0, { label: phrasebook.numbers.portability_latest_invoices_req, type: "checkbox", id: "portability_latest_invoices_req", name: "portability_latest_invoices_req", value: actualState.portability_latest_invoices_req })

    if (actualState.service_type === 'ITFS') {
      inputs.splice((index + 1), 0, { label: phrasebook.numbers.portability_options, type: "subsection", id: "portability_options" })
      inputs.splice((index + 2), 0, { label: phrasebook.numbers.between_in_country_carriers, type: "checkbox", id: "portability_options", name: "between in country carriers", value: actualState.portability_options.includes('between in country carriers') ? true : false })
      inputs.splice((index + 3), 0, { label: phrasebook.numbers.between_international_carriers, type: "checkbox", id: "portability_options", name: "between international carriers", value: actualState.portability_options.includes('between international carriers') ? true : false })
    }
  }

  if (actualState.declaration_letter_req === true) {
    var index = inputs.findIndex(p => p.id === "declaration_letter_req");
    inputs.splice((index + 1), 0, [{ label: phrasebook.numbers.declaration_letter_link, type: "file", id: "declaration_letter_link", name: "declaration_letter_link", accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' }, { label: phrasebook.common.uploaded_file, type: "info", value: actualState.declaration_letter_link }])
  }


  if (actualState.portability_forms === true) {
    var index = inputs.findIndex(p => p.id === "portability_forms");
    inputs.splice((index + 1), 0, [{ label: phrasebook.numbers.portability_forms_link, type: "file", id: "portability_forms_link", name: "portability_forms_link", accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' }, { label: phrasebook.common.uploaded_file, type: "info", value: actualState.portability_forms_link }])
  }

  if (actualState.prt_consentletter_req === true) {
    var index = inputs.findIndex(p => p.id === "prt_consentletter_req");
    inputs.splice((index + 1), 0, [{ label: phrasebook.numbers.prt_consentletter_link, type: "file", id: "prt_consentletter_link", name: "prt_consentletter_link", accept: 'application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document' }, { label: phrasebook.common.uploaded_file, type: "info", value: actualState.prt_consentletter_link }])
  }
  return inputs;
}

/* INFO */

const infoConditions = (phrasebook, selectedTypeNumber, inputs) => {


  if (selectedTypeNumber.service_type === 'DID' || selectedTypeNumber.service_type === 'SIP Trunking') {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.t38_fax_supported));

    inputs.splice(index + 1, 0, [{ label: phrasebook.numbers.outbound_calling_enabled, value: trueOrFalseIfExist(selectedTypeNumber.outbound_calling_enabled), tooltip: phrasebook.tooltip.outbound_calling_enabled }]);

    if (selectedTypeNumber.outbound_calling_enabled) inputs[index + 1].push({ label: phrasebook.numbers.outbound_call_display_format, value: selectedTypeNumber.outbound_call_display_format, tooltip: phrasebook.tooltip.outbound_call_display_format });
  }

  if (selectedTypeNumber.service_type === 'SIP Trunking') {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.t38_fax_supported));
    inputs.splice(index + 1, 0, { label: phrasebook.numbers.emergency_services, value: trueOrFalseIfExist(selectedTypeNumber.emergency_services), tooltip: phrasebook.tooltip.emergency_services });
  }
  var index_concurrent = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.concurrent_call_expandable));
  if (selectedTypeNumber.concurrent_call_expandable) {

    inputs[index_concurrent].splice(2, 0, { label: phrasebook.numbers.conc_df_callpernumber, value: ifZero(selectedTypeNumber.conc_df_callpernumber), tooltip: phrasebook.tooltip.conc_df_callpernumber });
  } else {
    inputs[index_concurrent].splice(2, 0, { label: phrasebook.numbers.conc_max_callpnumber, value: specialMaximum(selectedTypeNumber.conc_max_callpnumber), tooltip: phrasebook.tooltip.conc_max_callpnumber });
  }
  if (selectedTypeNumber.portability && selectedTypeNumber.portability_options && Array.isArray(selectedTypeNumber.portability_options)) {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.calling_card_usage_permitted));
    inputs.splice(index + 1, 0, [{ label: phrasebook.numbers.portability, value: 'subtitle' }, { label: phrasebook.numbers.portability_options, value: selectedTypeNumber.portability_options.map(e => e).join(",") }]);
  }
}

const requirementConditions = (phrasebook, selectedTypeNumber, inputs) => {
  if (selectedTypeNumber.service_type === 'UIFN') {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.business_registration_doc_req));
    inputs[index].push({ label: phrasebook.numbers.itu_assignment_notification_req, value: required(selectedTypeNumber.itu_assignment_notification_req), tooltip: phrasebook.tooltip.itu_assignment_notification_req })

  }
  if (selectedTypeNumber.end_user_address_req) {

    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.end_user_address_req));
    inputs[index].push({ label: phrasebook.numbers.end_user_address_type, value: selectedTypeNumber.end_user_address_type }, { label: phrasebook.numbers.end_user_address_proof_req, value: required(selectedTypeNumber.end_user_address_proof_req) })
  }

  if (selectedTypeNumber.end_user_address_proof_req) {

    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.end_user_address_proof_req));
    inputs[index].push({ label: phrasebook.numbers.end_user_address_proof_required, value: selectedTypeNumber.end_user_address_proof_required })
  }

  if (selectedTypeNumber.business_registration_doc_req) {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.business_registration_doc_req));
    inputs[index].push({ label: phrasebook.numbers.buss_reg_doctypes_req, value: selectedTypeNumber.buss_reg_doctypes_req })
  }
  if (selectedTypeNumber.portability) {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.numbers.authpers_passportholding_req));
    inputs.splice(index + 1, 0, [{ label: phrasebook.orders.porting_req, value: 'title' }, { label: phrasebook.numbers.prt_consentletter_req, value: required(selectedTypeNumber.prt_consentletter_req) }, { label: phrasebook.numbers.prt_hstcarriers_req, value: required(selectedTypeNumber.prt_hstcarriers_req) }, { label: phrasebook.numbers.portability_forms, value: required(selectedTypeNumber.portability_forms) }, { label: phrasebook.numbers.portability_latest_invoices_req, value: required(selectedTypeNumber.portability_latest_invoices_req) }]
    );
  }
}

export const tariffConditions = (phrasebook, selectedTypeNumber, inputs) => {
  if (selectedTypeNumber.service_type === 'SIP Trunking') {

    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.pricing.mrc));
    inputs.splice(index + 1, 0,
      [{ label: phrasebook.pricing.per_channel_charges, value: "subtitle" }, { label: phrasebook.pricing.nrc_channel_charges, value: ifZero(selectedTypeNumber.tariff.nrc_channel_charges), tooltip: phrasebook.tooltip.nrc_channel_charges }, { label: phrasebook.pricing.mrc_channel_charges, value: ifZero(selectedTypeNumber.tariff.mrc_channel_charges), tooltip: phrasebook.tooltip.mrc_channel_charges }]);

    inputs.splice(index + 2, 0, [{ label: phrasebook.pricing.outbound_charges, value: "subtitle" }, { label: phrasebook.pricing.outbound_charges_fixed, value: ifZero(selectedTypeNumber.tariff.outbound_charges_fixed), tooltip: phrasebook.tooltip.outbound_charges_fixed }, { label: phrasebook.pricing.outbound_charges_mobile, value: ifZero(selectedTypeNumber.tariff.outbound_charges_mobile), tooltip: phrasebook.tooltip.outbound_charges_mobile }, { label: phrasebook.pricing.outbound_charges_special, value: selectedTypeNumber.tariff.outbound_charges_special, tooltip: phrasebook.tooltip.outbound_charges_special }]);

  }
  if (selectedTypeNumber.service_type === 'ITFS' || selectedTypeNumber.service_type === 'UIFN') {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.pricing.mrc));
    inputs.splice(index + 1, 0, [{ label: phrasebook.pricing.per_minute_rate, value: 'subtitle' }, { label: phrasebook.pricing.fix_usage_rate, value: ifZero(selectedTypeNumber.tariff.fix_usage_rate) }, { label: phrasebook.pricing.mobile_usage_rate, value: ifZero(selectedTypeNumber.tariff.mobile_usage_rate) }, { label: phrasebook.pricing.payphone_usage_rate, value: ifZero(selectedTypeNumber.tariff.payphone_usage_rate) }])
  }
  if (selectedTypeNumber.service_type === 'DID' || selectedTypeNumber.service_type === 'SIP Trunking') {

    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.pricing.mrc));
    inputs.splice(index + 1, 0, [{ label: phrasebook.pricing.inbound_charges_per_minute, value: "subtitle" }, { label: phrasebook.pricing.inbound_charges, value: ifZero(selectedTypeNumber.tariff.inbound_charges) }]);
  }
}

const generalConditions = (phrasebook, selectedTypeNumber, inputs) => {
  // TODO: TO REVISE WITH HC REGARDING THE CITIES SAVING IN DB AND SHOWING
  // if (selectedTypeNumber.service_type === 'DID' || selectedTypeNumber.service_type === 'SIP Trunking') {
  //   var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.profile.jurisdiction));
  //   inputs.splice(index + 1, 0, [{ label: phrasebook.references.cities, value: selectedTypeNumber.cities.map(e => e.city).join(", ") }, { label: phrasebook.common.number, value: selectedTypeNumber.number_type, tooltip: phrasebook.tooltip.number_type }])
  // }
  if (selectedTypeNumber.service_type === 'UIFN') {
    var index = inputs.findIndex(p => Array.isArray(p) && p.find(k => k.label === phrasebook.profile.jurisdiction));
    if (selectedTypeNumber.service_access_code) inputs.splice(index + 1, 0, { label: phrasebook.numbers.service_access_code, value: selectedTypeNumber.service_access_code });
  }
}



export const serviceNumberTypeInfoDetails = (phrasebook, selectedTypeNumber) => {
  var info = [

    [{ label: phrasebook.common.characteristics, value: 'title' },
    {
      label: phrasebook.numbers.accessibility, value: selectedTypeNumber.accessibility ? selectedTypeNumber.accessibility.map(e => {
        return capitalizeFirstLetter(e.replace('_', ' '))
      }).join(", ") : undefined
    },
    { label: phrasebook.numbers.accessibility_remarks, tooltip: phrasebook.tooltip.accessibility_remarks, value: selectedTypeNumber.accessibility_remarks }],

    [{ label: phrasebook.numbers.provisioning_lead_time, value: ifZero(selectedTypeNumber.provisioning_lead_time), tooltip: phrasebook.tooltip.provisioning_lead_time },
    { label: phrasebook.numbers.maximum_call_duration, value: specialMaximum(selectedTypeNumber.maximum_call_duration), tooltip: phrasebook.tooltip.maximum_call_duration }],

    [
      { label: phrasebook.numbers.t38_fax_supported, value: trueOrFalseIfExist(selectedTypeNumber.t38_fax_supported) },
      { label: phrasebook.numbers.calling_card_usage_permitted, value: trueOrFalseIfExist(selectedTypeNumber.calling_card_usage_permitted) },
      { label: phrasebook.numbers.local_caller_cli_supported, value: trueOrFalseIfExist(selectedTypeNumber.local_caller_cli_supported) }],


    [{ label: phrasebook.numbers.concurrent_capabilities, value: 'subtitle' },

    { label: phrasebook.numbers.concurrent_call_expandable, value: trueOrFalse(selectedTypeNumber.concurrent_call_expandable), tooltip: phrasebook.tooltip.concurrent_call_expandable },
    { label: phrasebook.numbers.concurrent_maximum_calls, value: noMaximum(selectedTypeNumber.concurrent_maximum_calls), tooltip: phrasebook.tooltip.concurrent_maximum_calls }],
  ]
  if (selectedTypeNumber.additional_remarks) info.splice(3, 0, [{ label: phrasebook.numbers.additional_remarks, value: selectedTypeNumber.additional_remarks }])
  infoConditions(phrasebook, selectedTypeNumber, info);
  return <div class="section-block">
    {info.map(row => {
      if (Array.isArray(row)) {
        return <div class="section-block mt-3">
          {row.map(rowblock => {
            if (rowblock.value === 'title') return <h3 class="mb-2"> <strong>{rowblock.label}</strong></h3>
            else if (rowblock.value === 'subtitle') return <h4> {rowblock.label}</h4>
            else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
              <span>{rowblock.label} <Tooltip tooltip={rowblock.tooltip}></Tooltip> </span>
              <span><strong>{rowblock.value}</strong> </span>
            </div>
          })}
        </div>
      }
      if (row.value === 'title') return <h3 class="mb-2"> <strong>{row.label}</strong></h3>
      else if (row.value === 'subtitle') return <h4> {row.label}</h4>
      else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
        <span> {row.label} <Tooltip tooltip={row.tooltip}></Tooltip></span>
        <span><strong>{row.value}</strong> </span>
      </div>
    })}
  </div>

}

export const serviceNumberTypeRequirements = (phrasebook, selectedTypeNumber) => {
  var requirements = [
    [{ label: phrasebook.orders.customer_information_req, value: 'title' },

    { label: phrasebook.numbers.purpose_application_req, value: required(selectedTypeNumber.purpose_application_req), tooltip: phrasebook.tooltip.purpose_application_req },
    { label: phrasebook.numbers.declaration_letter_req, value: required(selectedTypeNumber.declaration_letter_req) },
    { label: phrasebook.numbers.usage_forecast_req, value: required(selectedTypeNumber.usage_forecast_req), tooltip: phrasebook.tooltip.usage_forecast_req }],

    [{ label: phrasebook.numbers.business_req, value: 'title' },

    { label: phrasebook.numbers.business_nature_req, tooltip: phrasebook.tooltip.business_nature_req, value: required(selectedTypeNumber.business_nature_req) },
    { label: phrasebook.numbers.business_registration_req, tooltip: phrasebook.tooltip.business_registration_req, value: required(selectedTypeNumber.business_registration_req) },
    { label: phrasebook.numbers.business_registration_doc_req, value: required(selectedTypeNumber.business_registration_doc_req) }]
    ,
    [{ label: phrasebook.numbers.end_user_req, value: 'title' },

    { label: phrasebook.numbers.end_user_name_req, value: required(selectedTypeNumber.end_user_name_req), tooltip: phrasebook.tooltip.end_user_name_req },
    { label: phrasebook.numbers.end_user_contact_req, value: required(selectedTypeNumber.end_user_contact_req), tooltip: phrasebook.tooltip.end_user_contact_req },
    { label: phrasebook.numbers.end_user_address_req, value: required(selectedTypeNumber.end_user_address_req), tooltip: phrasebook.tooltip.end_user_address_req }

    ],

    [{ label: phrasebook.numbers.authorised_person_passport_id_req, value: required(selectedTypeNumber.authorised_person_passport_id_req) },
    { label: phrasebook.numbers.authpers_passportholding_req, value: required(selectedTypeNumber.authpers_passportholding_req) }]
  ]

  requirementConditions(phrasebook, selectedTypeNumber, requirements);
  return <div class="section-block">
    {requirements.map(row => {
      if (Array.isArray(row)) {
        return <div class="section-block mt-3">
          {row.map(rowblock => {
            if (rowblock.value === 'title') return <h3 class="mb-2"> <strong>{rowblock.label}</strong></h3>
            else if (rowblock.value === 'subtitle') return <h4> {rowblock.label}</h4>
            else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
              <span> {rowblock.label} <Tooltip tooltip={rowblock.tooltip}></Tooltip></span>
              <span><strong>{rowblock.value}</strong> </span>
            </div>
          })}
        </div>
      }
      if (row.value === 'title') return <h3 class="mb-2"> <strong>{row.label}</strong></h3>
      else if (row.value === 'subtitle') return <h4> {row.label}</h4>
      else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
        <span> {row.label} <Tooltip tooltip={row.tooltip}></Tooltip></span>
        <span><strong>{row.value}</strong> </span>
      </div>
    })}
  </div>
}

export const serviceNumberTypeTariff = (phrasebook, selectedTypeNumber) => {
  const currencies = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'HKD': 'HK$',
    'CNY': '¥',
    'SGD': '$',
  }
  var tariff = [


    [{ label: phrasebook.headerlinks.pricing, value: 'title' },


    { label: phrasebook.references.currency, value: selectedTypeNumber.tariff.currency, tooltip: phrasebook.tooltip.currency }
      ,

    { label: phrasebook.pricing.nrc, value: ifZero(selectedTypeNumber.tariff.nrc), tooltip: phrasebook.tooltip.nrc },
    { label: phrasebook.pricing.mrc, value: ifZero(selectedTypeNumber.tariff.mrc), tooltip: phrasebook.tooltip.mrc }
    ]
  ]
  tariffConditions(phrasebook, selectedTypeNumber, tariff);
  return <div class="section-block">
    {tariff.map(row => {
      if (Array.isArray(row)) {
        return <div class="section-block mt-3">
          {row.map(rowblock => {
            if (rowblock.value === 'title') return <h3 class="mb-2"> <strong>{rowblock.label}</strong></h3>
            else if (rowblock.value === 'subtitle') return <h4> {rowblock.label}</h4>
            else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
              <span>{rowblock.label} <Tooltip tooltip={rowblock.tooltip}></Tooltip></span>
              <span>{currencies[selectedTypeNumber.tariff.currency]} {rowblock.value}</span>
            </div>
          })}
        </div>
      }
      if (row.value === 'title') return <h3 class="mb-2"> <strong>{row.label}</strong></h3>
      else if (row.value === 'subtitle') return <h4> {row.label}</h4>
      else return <div class="d-flex justify-content-between border-bottom py-h mb-h">
        <span>{row.label} <Tooltip tooltip={row.tooltip}></Tooltip></span>
        <span>{currencies[selectedTypeNumber.tariff.currency]} {row.value}</span>
      </div>
    })}
  </div>
}

export const serviceNumberTypeGeneral = (phrasebook, selectedTypeNumber) => {
  var general = [
    { label: `${phrasebook.common.general} ${phrasebook.headerlinks.information}`, value: 'title' },
    [{ label: phrasebook.numbers.service_type, value: selectedTypeNumber.service_type },
    { label: phrasebook.profile.jurisdiction, value: selectedTypeNumber.jurisdiction },
    ]
  ]
  if ((selectedTypeNumber.service_type === 'DID' || selectedTypeNumber.service_type === 'SIP Trunking') && selectedTypeNumber.cities) {
    general.push({ label: phrasebook.references.cities, value: selectedTypeNumber.cities.map(e => e.city).join(", ") })
  }
  generalConditions(phrasebook, selectedTypeNumber, general);
  return <div class="section-block">
    {general.map(row => {
      if (Array.isArray(row)) {
        return <div class="section-block">
          {row.map(rowblock => {
            if (rowblock.value === 'title') return <h3 class="mb-2"> <strong>{rowblock.label}</strong></h3>
            else if (rowblock.value === 'subtitle') return <h4> {rowblock.label}</h4>
            else return <div class="d-flex mb-1"><span><Tooltip tooltip={rowblock.tooltip}></Tooltip> {rowblock.label}:  <strong>{rowblock.value}</strong></span></div>
          })}
        </div>
      }
      else if (row.value === 'title') return <h3 class="mb-2"> <strong>{row.label}</strong></h3>
      else if (row.value === 'subtitle') return <h4> {row.label}</h4>
      else return <div class="d-flex mb-1"><span><Tooltip tooltip={row.tooltip}></Tooltip> {row.label}:  <strong>{row.value}</strong></span></div>
    })}
  </div>
}

export const serviceNumberTypeInfo = (phrasebook, selectedTypeNumber, tariff = true) => {
  return <form class="box p-1 p-sm-2 p-lg-3">
    <div class="container-xs p-0">
      {/* <h2 class="box-title pb-1 mb-1">{phrasebook.orders.submit_order}</h2> */}
      {serviceNumberTypeGeneral(phrasebook, selectedTypeNumber)}
      <hr class="dotted my-3" />
      {tariff ? serviceNumberTypeTariff(phrasebook, selectedTypeNumber) : null}
      {serviceNumberTypeInfoDetails(phrasebook, selectedTypeNumber)}
      {serviceNumberTypeRequirements(phrasebook, selectedTypeNumber)}
      {selectedTypeNumber.additional_remarks ? <><hr class="dotted my-3" />
        <div class="section-block">
          <div class="d-flex mb-1"><span>{phrasebook.numbers.additional_remarks}:  <strong>{selectedTypeNumber.additional_remarks}</strong></span></div>
        </div></> : null}
    </div>
  </form>
}
